import { AxiosRequestConfig } from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { getPublicAxios } from './publicAxios';
import { UsePostResponse } from './usePost';

/**
 * `usePost` for anonymous callers: identical signature and `{ Data }` envelope, but routed through the
 * interceptor-free instance in `publicAxios`, so no bearer token is sent and a 401 surfaces as a plain
 * query error instead of tripping `App`'s response interceptor into an Auth0 logout.
 */
export const usePublicPost = <T>(
  url: string,
  axiosCfg: AxiosRequestConfig = {},
  queryOptions: UseQueryOptions<UsePostResponse<T>, Error> = {}
): UsePublicPostResult<T> => {
  const { queryKey = [], ...restQueryOptions } = queryOptions;
  const getResult = useQuery<UsePostResponse<T>, Error>({
    queryKey: [url, ...queryKey],

    queryFn: async () => {
      const axiosRes = await getPublicAxios().request<UsePostResponse<T>>({ url, method: 'POST', ...axiosCfg });
      return axiosRes.data;
    },

    retry: false,
    ...restQueryOptions,
  });

  return getResult;
};

export type UsePublicPostResult<T> = UseQueryResult<UsePostResponse<T>, Error>;
